import React from 'react';
import { AvatarGroup } from "@mui/material";
import moment from "moment";
import UserAvatar from './UserAvatar';

const AvatarGroupList = ({ 
  users, 
  setAnchorEl, 
  isColabrotar, 
  selectedUsers, 
  filterUserById,
  boardOwnerId 
}) => {
  return (
    <AvatarGroup
      total={users?.length}
      renderSurplus={(surplus) => (
        <span onClick={(event) => setAnchorEl(event?.currentTarget)}>
          +{users?.length - 4}
        </span>
      )}
      className="avatar-group cursor-pointer avatar-group-border">
      {(isColabrotar ? users : users?.sort((a, b) => {
        const dateA = moment(a?.last_seen);
        const dateB = moment(b?.last_seen);
        return dateB - dateA;
      }))?.map((user) => (
        <UserAvatar
          key={`user-avtar-${user.user_id}`}
          user={user}
          isColabrotar={isColabrotar}
          selectedUsers={selectedUsers}
          filterUserById={filterUserById}
          boardOwnerId={boardOwnerId}
        />
      ))}
    </AvatarGroup>
  );
};

export default AvatarGroupList; 